import { FacilityBagAuditPage } from '@/pages/facility/workflows/bag-audit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/facility/bag-audit')({
	component: FacilityBagAuditPage,
});
